import { useState } from 'react';
import { Button, message } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { productService } from '@/services/product.service';
import { exportReport } from '@/utils/exportReport';
import { buildExportRows } from '../parts/product-export-helpers';
import type { ProductListQuery } from '@/services/queryKeys';

interface ExportProductButtonProps {
  filter: Omit<ProductListQuery, 'page' | 'page_size'>;
}

const FIXED_HEADERS = [
  'STT',
  'Tên sản phẩm',
  'Tên hiển thị',
  'Mã sản phẩm',
  'Danh mục',
  'Thương hiệu',
  'Hình thức bán',
  'Trạng thái',
  'Quản lý tồn kho',
  'Mã biến thể',
  'Mô hình giá',
  'Giá niêm yết',
  'Có thể bán',
  'Hiển thị',
];

export function ExportProductButton({ filter }: ExportProductButtonProps) {
  const [loading, setLoading] = useState(false);

  const handleExport = async () => {
    setLoading(true);
    try {
      const { products, variantsByProduct, attrColumns } = await productService.exportList(filter);

      const attrHeaders = attrColumns.map((a) => a.name);
      const dataRows = buildExportRows(products, variantsByProduct, attrColumns);

      exportReport({
        filename: `san-pham-${new Date().toISOString().slice(0, 10)}`,
        format: 'excel',
        title: 'Danh sách sản phẩm',
        sheets: [
          {
            name: 'Sản phẩm',
            columns: [...FIXED_HEADERS, ...attrHeaders].map((header, idx) => ({
              key: String(idx),
              header,
            })),
            rows: dataRows.map((row) =>
              Object.fromEntries(row.map((cell, idx) => [String(idx), cell])),
            ),
          },
        ],
      });

      void message.success(`Xuất thành công ${products.length} sản phẩm`);
    } catch {
      void message.error('Xuất Excel thất bại');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button icon={<DownloadOutlined />} loading={loading} onClick={() => void handleExport()}>
      Xuất Excel
    </Button>
  );
}
